export const StatusConstants = {
  STATUS_SUCCESS: "Successful",
  STATUS_INITIATED: "Initiated",
  STATUS_PROCESSING: "Processing",
  STATUS_REVERSED: "Reversed",
  STATUS_FAILED: "Failed",
  STATUS_PENDING: "Pending",
};

export const BASE_API_URL = "https://api.mypennytree.com/api/v2";

// export const BASE_API_URL = "http://localhost:13784/api/v1"

export const PAYAZA_AUTH = "";
export const PAYAZA_URL = "";
export const X_PUSH_MESSAGE_KEY = "";
export const x_api_key = 12;
export const SEERBIT_URL = "";
export const SEERBIT_KEY = "";
export const SEERBIT_POCKET = "";
export const SEERBIT_EMAIL = "";
export const SEERBIT_PASS = "tech";
export const VFD_KEY = "";
export const VFD_WALLET_CREDS = "";
export const FLW_KEY = "";
export const PAYSTACK_SECRET = "";
